// extracted by mini-css-extract-plugin
export default {"wrapper":"FlowsSettings_wrapper_mvvS0","label":"FlowsSettings_label_KkiMH","ignoreLabelsInput":"FlowsSettings_ignoreLabelsInput_ejZ6n"};